<style lang="scss">
	.channelform .ivu-form-item-error-tip{
		z-index: 99;
	}
</style>
<template>
    <div class="channelform">
		<Breadcrumb class="tablelist-header" v-if="!querytype">
            <BreadcrumbItem to="/">渠道SFP产品{{type==='edit'?'编辑':(type==='add'?'添加':'查看')}}</BreadcrumbItem>
        </Breadcrumb>
        <compWrapper title="基本信息" theme="primary">
            <compBase :alltype="type" :basedata="compbasedata" ref="refbase" @on-currency="Allcurrency"></compBase>
        </compWrapper>
        <compWrapper title="价格信息" theme="info">
            <compPricenews :alltype="type" :pricedata="comppricedata" ref="refprice" :compcurrency="newcurrency"></compPricenews>
        </compWrapper>
        <compWrapper title="其他信息" theme="info">
            <compFormQuery v-if="type=='query'" class="margin-top-15 margin-right-15" :formdata="getOther" :value="formData" :labelWidth="140"></compFormQuery>
            <compFormEdit v-else class="margin-top-15 margin-right-15" :formdata="getOther" v-model="formData" :labelWidth="140"></compFormEdit>
			<template v-if="type!='query'" slot="footer">
				<vButton class="margin-right-20" theme="primary" @click="submit">保存</vButton>
				<vButton class="margin-right-20" @click="cancel">取消</vButton>
			</template>
		</compWrapper>
		<compWrapper title="操作历史" theme="gray" v-if="type=='query'">
            <compLog :data="logList"></compLog>
        </compWrapper>
		<!-- <div class="text-right" v-if="type!='query'">
			<vButton class="margin-right-10" theme="primary" @click="submit">保存</vButton>
			<vButton @click="cancel">取消</vButton>
		</div> -->
    </div>
</template>
<script>
import {
	HttpGetChannelOne,
	HttpGetTemplated,
	HttpSaveChannelOne
} from '@/service/products/channel'

import compBase from './compbase'
import compPricenews from './comppricenews'
import { setTimeout } from 'timers'
import { mapState, mapGetters } from "vuex";
import {
    HttpSysOpLog
} from '@/service/boss/allot';

export default {
	props:['activeids','querytype'],
    data(){
        return {
			formData:{
				tempName:'',
				amazonProductSerialStatus:0,
			},
			type: this.$route.params.type,
			id: this.$route.query.id,
			compbasedata:{},
			comppricedata:{},
			otherType:'',
			newcurrency:'',
			logList:[],
		}
    },
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
		compBase,
		compPricenews,
	},
	created(){
        if(this.activeids){
            this.id = this.activeids
            this.type = this.querytype
        }else{
            this.id = this.id
            this.type = this.type
		}
		this.showquery = this.type == 'query' || this.type == 'edit'
        this.getDetail()
    },
    computed:{
		...mapState('boss', ['products', 'accountTypes', 'accounts']),

        getOther(){
            return [
                // 1
                {
					label: "Item Label",
					key: "fnSku",
					tag: "vInput",
					required: false,
					formItem:{
						tip: this.type=='query' ? '' : '<div class="color-error">渠道对应的仓库编号，如果是亚马逊则为FNSKU</div>',
					}
                },
                // 2
                {
					label: "URL",
					key: "channelUrl",
					tag: "vInput",
					required: false,
					formItem:{
						tip: this.type=='query' ? '' : '<div class="color-error">Channel URL</div>',
					}
                },
                // 3
                {
					label: "平台售价",
					key: "listingPrice",
					tag: "vInput",
					required: false,
					query: true,
					formItem:{
						tip: this.type=='query' ? '' : '<div class="color-error">每天从亚马逊平台抓取并更新</div>',
					},
					show:this.otherType == 'amazon' && this.showquery,
                },
                // 4
                {
					label: "平台售价的更新时间",
					key: "listingPriceDate",
					tag: "vInput",
					required: false,
					query: true,
					show:this.otherType == 'amazon' && this.showquery,
                },
                // 5
                {
					label: "是否启用透明计划",
					key: "amazonProductSerialStatus",
					tag: "vRadio",
					required: false,
					show: this.type != 'query' && global.SYSID == 1,
					// valueText: this.formData.amazonProductSerialStatus == '1' ? '是' : '否',
					// props: {
					// 	strict: false,
					// },
					options: [{
						trueValue: 1,
						label: '是'
					}, {
						trueValue: 0,
						label: '否'
					}],
                },
                {
					label: "是否启用透明计划",
					key: "amazonProductSerialStatus",
					show: this.type == 'query' && global.SYSID == 1,
					valueText: this.formData.amazonProductSerialStatus == 1 ? '是' : '否'
                },
                // 6
                {
					label: "Propert",
					key: "property",
					tag: "vInput",
					query: true,
					show:this.type != 'add' && this.otherType == 'amazon',
                },
                // 7
                {
					label: "Template",
					key: "tempName",
					tag: "vInput",
					query: true,
					show:this.type != 'add' && this.otherType == 'amazon',
                },
            ]
        }
    },
    methods:{
		getDetail(){
			if(this.type == 'add') return
			HttpGetChannelOne({
				id:this.id
			}).then(res=>{
				this.formData = res.data;
				this.handledata(res.data)
				if(res.data.templateId){
					this.templateName(res.data.templateId)
				}

			},err=>{

			})
			if(this.type=='query'){
				// 请求操作历史
				HttpSysOpLog({
					search: {
						EQ_opDataId: this.id,
						EQ_opModel: 'Product_Channel'
					}
				}).then(res => {
					// console.log(res.data)
					this.logList = res.data.content
				}, err => {

				})
			}
		},
		templateName(tempid){
			HttpGetTemplated({
				id:tempid
			}).then(res=>{
				this.$set(this.formData,'tempName',res.data.name)
			},err=>{

			})
		},
		handledata(data){
			// console.log(data)
			let accountItem = this.accounts.filter(item=>{
				// console.log(item)
				if(item.flag == data.accountFlag){
					return item
				}
			})
			this.newcurrency = data.currencyCode;
			// console.log(accountItem)
			this.otherType = accountItem[0].type.toLowerCase()

			this.$set(this.$data,'compbasedata',data || {})
			this.$set(this.$data,'comppricedata',data || {})
		},
		Allcurrency(value){
			// console.log(value)
			this.newcurrency = value
		},
		async submit(){
			// console.log(this.$refs.refbase)
			// console.log(this.$refs.refprice)
			const valid = await this.$refs['refbase'].validate();
			if (!valid) return;

			let basedata = this.$refs.refbase.formData;
			let refdata = this.$refs.refprice;

			let flag1 = false;
			// console.log(this.$refs.refbase)
			if(this.$refs.refbase.formData.type == 'bundle'){
				this.$refs.refbase.formList.map(item=>{
					if(item.qty==0){
						flag1 = true
					}
				})

				if(flag1){
					this.$VMessage.error('组合产品列表中的数量不能为0');
					return;
				}
			}
			if(refdata.formData.businessPriceFlag == true){
				refdata.formData.productChannelBusiness.quantityPrice1 = refdata.quantityPrice1
				refdata.formData.productChannelBusiness.quantityPrice2 = refdata.quantityPrice2
				refdata.formData.productChannelBusiness.quantityPrice3 = refdata.quantityPrice3
				refdata.formData.productChannelBusiness.quantityPrice4 = refdata.quantityPrice4
				refdata.formData.productChannelBusiness.quantityPrice5 = refdata.quantityPrice5

				refdata.formData.productChannelBusiness.percent1 = refdata.present1
				refdata.formData.productChannelBusiness.percent2 = refdata.present2
				refdata.formData.productChannelBusiness.percent3 = refdata.present3
				refdata.formData.productChannelBusiness.percent4 = refdata.present4
				refdata.formData.productChannelBusiness.percent5 = refdata.present5
			}

			basedata.productChannelRelateList = this.$refs.refbase.formList

			let otherdata = {
				fnSku:this.formData.fnSku,
				channelUrl:this.formData.channelUrl,
				listingPrice:this.formData.listingPrice,
				listingPriceDate:this.formData.listingPriceDate,
				amazonProductSerialStatus:this.formData.amazonProductSerialStatus,
				property:this.formData.property,
				tempName:this.formData.tempName

			}
			// console.log(otherdata,'ppppp')
			// console.log(newrefdata)
			// console.log(basedata)

			let newrefdata = refdata.formData
			let data = {
				...newrefdata,
				...basedata,
				...otherdata,
			}

			// console.log(data)
			HttpSaveChannelOne({
				...data,
				orgId:global.SYSID,
			}).then(res=>{
				this.$VMessage.success(res.message);
				this.$router.push({
                    name: "prochannelList"
                })
			},err=>{
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			})
		},
		cancel(){
			if(this.querytype == 'edit'){
                this.$emit('on-close')
            }else{
                this.$router.push({
                    name: "prochannelList"
                })
            }
		}
    }
}
</script>
